import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, finalize, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EncrypDepcrypService } from '../_services';
import { AlertifyService } from '../_services/common/alertify.service';

  
  
  @Injectable()
  export class EncryptionInterceptor implements HttpInterceptor {
  
 
    constructor(
      private encryptionService: EncrypDepcrypService, 
      private alertifyService: AlertifyService
    ) {}
  
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      if (this.shouldEncryptRequest(request)) {
        const clonedRequest = this.getEncryptedRequest(request);
        return this.handleRequest(clonedRequest, next);
      }
  
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => this.handleError(error)),
        finalize(() => 
          console.log('Request handling finalized')
      )
      );
    }
  
    private shouldEncryptRequest(request: HttpRequest<any>): boolean {
      return environment.isCloud && 
             !request.url.includes('Documents/') && 
             !request.url.includes('LabIntegration/') && 
            //  !request.url.includes('User/') && 
             !request.url.includes('assets/');
    }
  
    private getEncryptedRequest(request: HttpRequest<any>): HttpRequest<any> {
      const [baseUrl, apiUrl] = request.url.split('api/');
      const encryptedUrl = this.encryptionService.encrypt(apiUrl);
      let clonedRequest = request.clone({ url: `${baseUrl}api/${encryptedUrl}` });
  
      if (['POST', 'PUT', 'PATCH'].includes(request.method)) {
        clonedRequest = request.body instanceof FormData 
          ? this.encryptFormData(request, clonedRequest) 
          : clonedRequest.clone({ body: this.encryptionService.encryptBody(request.body) });
      }
  
      return clonedRequest;
    }
  
    private encryptFormData(request: HttpRequest<any>, clonedRequest: HttpRequest<any>): HttpRequest<any> {
      const formData = new FormData();
      request.body.forEach((value: any, key: string) => {
        console.log(`key: ${key}, value: ${value}`);
        formData.append(key, value instanceof File ? value : this.encryptionService.encrypt(value));
        // formData.append(key, value instanceof number[] ? value : this.encryptionService.encrypt(value));
      });
      return clonedRequest.clone({ body: formData });
    }
  
    private handleRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(request).pipe(
        map((event: HttpEvent<any>) => this.decryptResponse(event)),
        catchError((error: HttpErrorResponse) => this.handleError(error)),
        finalize(() => console.log('Request handling finalized'))
      );
    }
  
    private decryptResponse(event: HttpEvent<any>): HttpEvent<any> {
      // console.log("event: ", event);
      if (event instanceof HttpResponse && event.body) {
        // console.log("event.body: ", event.body);
        const decryptedBody = this.encryptionService.decrypt(event.body.response);
        // console.log("event.body.response: ", event.body.response);
        try {
          const parsedBody = JSON.parse(decryptedBody);
          // console.log("parsedBody: ", parsedBody);
          return event.clone({ body: parsedBody });
        } catch(e) {
          console.log("Catch Error: ", e);
          // Parsing failed, return the original decrypted string
        }
      }
      return event;
    }
  
    private handleError(error: HttpErrorResponse): Observable<never> {
      switch (error.status) {
        case 500:
          this.alertifyService.error('500 Internal Server Error');
          break;
        case 415:
          this.alertifyService.error('Unsupported Media Type');
          break;
        default:
          console.log('An HTTP error occurred', error);
      }
      return throwError(() => error);
    }
  }
  